
export const BASE_URL = "https://apiphotoapp.platformown.com";

export const UPLOAD_URL = `${BASE_URL}/upload`;

export const AUTH_URL = `${BASE_URL}/auth`;

export const API_URL = `${BASE_URL}/api`;

